// client/src/components/notes/NoteCard.jsx
// One note in a list: title, text, associations (linked to their pages) and
// who changed it last. Clicking the card body opens the editor.

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { linkKey, linkPath, typeLabel } from './noteTypes';

const fmt = (v) => {
  if (!v) return '';
  const d = new Date(typeof v === 'string' && v.includes(' ') && !v.includes('T') ? v.replace(' ', 'T') : v);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};

export default function NoteCard({ note, tenantId, onOpen, hideLink = () => false, compact = false }) {
  const { t } = useTranslation();
  const links = (note.links || []).filter((l) => !hideLink(l));
  const unassociated = (note.links || []).length === 0;
  const who = note.modifiedByName || note.createdByName;

  return (
    <article className={`notes-card${compact ? ' notes-card--compact' : ''}${unassociated ? ' notes-card--pinned' : ''}`}>
      <button type="button" className="notes-card__open" onClick={onOpen} aria-label={`${t('notes.editNote', 'Edit note')}: ${note.title || note.body.slice(0, 40)}`}>
        {note.title && <span className="notes-card__title">{note.title}</span>}
        {note.body && <span className="notes-card__body">{note.body}</span>}
      </button>

      {!compact && unassociated && (
        <div className="notes-card__links">
          <span className="notes-chip notes-chip--muted">{t('notes.unassociated', 'Not associated')}</span>
        </div>
      )}
      {links.length > 0 && (
        <ul className="notes-card__links" aria-label={t('notes.associatedWith', 'Associated with')}>
          {links.map((l) => {
            const to = linkPath(tenantId, l);
            const inner = (
              <>
                <span className="notes-chip__type">{typeLabel(t, l.type)}</span>
                <span className="notes-chip__label">{l.label}</span>
              </>
            );
            return (
              <li key={linkKey(l)} className="notes-chip" title={l.sublabel || undefined}>
                {to ? <Link to={to}>{inner}</Link> : inner}
              </li>
            );
          })}
        </ul>
      )}

      <div className="notes-card__meta surface-muted">
        {fmt(note.modifiedon)}{who ? ` · ${who}` : ''}
      </div>
    </article>
  );
}
